import React, { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import Swal from 'sweetalert2';
import '../../Styles/User/AddUsers.css';

const AddUsers = ({ onClose, onUserAdded }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setSelectedFile(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!selectedFile) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a CSV file to upload.',
      });
      return;
    }
  
    const formData = new FormData();
    formData.append('file', selectedFile);
  
    setIsUploading(true);
  
    axiosInstance
      .post('accounts/bulkuserupload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        const { status, message, data } = response.data;
  
        if (status === 'success') {
          let successText = `${data.created_users} users created successfully!`;
  
          if (data.skiped_rows > 0) {
            successText += `\n${data.skiped_rows} rows were skipped due to errors.`;
          }
  
          if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
            successText += `\n\n<strong>Errors:</strong>\n${data.errors.join('\n')}`;
          }
  
          Swal.fire({
            icon: 'success',
            title: 'Upload Successful',
            html: successText.replace(/\n/g, '<br/>'), // Format new lines correctly
          });

          if (typeof onUserAdded === 'function') {
            onUserAdded();
          }

          if (typeof onClose === 'function') {
            onClose();
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Upload Failed',
            text: message || 'Error uploading file.',
          });
        }
  
        setIsUploading(false);
      })
      .catch((error) => {
        const { message, errors } = error.response?.data || {};
        let errorText = message || 'Error uploading file.';
  
        if (errors && Array.isArray(errors) && errors.length > 0) {
          errorText += `\n\n<strong>Errors:</strong>\n${errors.join('\n')}`;
        }
  
        Swal.fire({
          icon: 'error',
          title: 'Error',
          html: errorText.replace(/\n/g, '<br/>'),
        });
  
        setIsUploading(false);
      });
  };

  return (
    <div className="bulk-upload-card">
      <div className="bulk-upload-header">
        <h2>Bulk User Upload</h2>
        <p>Upload a CSV or Excel file to create users in one go.</p>
      </div>

      <form className="bulk-upload-form" onSubmit={handleSubmit}>
        <label className="bulk-upload-field" htmlFor="bulk-user-file-input">
          Select File
        </label>

        <input
          id="bulk-user-file-input"
          className="bulk-upload-input"
          type="file"
          accept=".csv,.xls,.xlsx"
          onChange={handleFileChange}
          required
        />

        <div className="bulk-upload-filename">
          {selectedFile ? selectedFile.name : 'No file selected'}
        </div>

        <p className="bulk-upload-hint">Supported formats: .csv, .xls, .xlsx</p>

        <div className="bulk-upload-actions">
          <button
            type="button"
            className="bulk-upload-btn bulk-upload-btn-secondary"
            onClick={onClose}
            disabled={isUploading}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="bulk-upload-btn bulk-upload-btn-primary"
            disabled={isUploading}
          >
            {isUploading ? 'Uploading...' : 'Upload Users'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUsers;
